import { render, staticRenderFns } from "./CollectionBook.vue?vue&type=template&id=d37d9004"
import script from "./CollectionBook.vue?vue&type=script&lang=js"
export * from "./CollectionBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports